import asyncComponentLoader from '@/shared/lib/loader';

import { ROUTES } from './paths';
import { servicesSharedRoutes } from './shared';
import { PageRoute } from './types';

export const servicesRoutes: PageRoute[] = [
  {
    component: asyncComponentLoader(() => import('@/features/services/pages/ServicesPage')),
    path: ROUTES.AUTHORIZED.SERVICES,
    title: 'Services',
  },
  {
    component: asyncComponentLoader(() => import('@/features/services/pages/ServiceSuppliers')),
    path: ROUTES.AUTHORIZED.SERVICE_SUPPLIERS,
    title: 'Service Suppliers',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/service-tasks/pages/ServiceTasksBoardPage'),
    ),
    path: ROUTES.AUTHORIZED.SERVICE_ORDERS,
    title: 'Tasks',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/service-tasks/pages/CampaignOverview'),
    ),
    path: `${ROUTES.AUTHORIZED.CAMPAIGN_OVERVIEW}/:id`,
    title: 'Campaign Overview',
  },
  ...servicesSharedRoutes,
];
